import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { LandingPage } from "./components/LandingPage";
import { CharacterCreator } from "./components/CharacterCreator";
import { ThemeProvider } from "@/components/theme-provider";
import { CoreSkills } from "@/components/rulebook/CoreSkills";
import { Patrons } from "@/components/rulebook/Patrons";
import { OtherworldlyGifts } from "@/components/rulebook/OtherworldlyGifts";
import { ChallengeOf13 } from "@/components/rulebook/ChallengeOf13";
import { FestiveGames } from "@/components/rulebook/FestiveGames";
import { Cabals } from "@/components/rulebook/Cabals";
import { BasicTerms } from "@/components/rulebook/BasicTerms";
import { WealthLevel } from "@/components/rulebook/WealthLevel";
import { LifeAndDeath } from "@/components/rulebook/LifeAndDeath";
import { Combat } from "@/components/rulebook/Combat";
import { Spellcasting } from "@/components/rulebook/Spellcasting";
import { BandsAndSigns } from "@/components/rulebook/BandsAndSigns";
import "./index.css";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export function App() {
  return (
    <ThemeProvider defaultTheme="system" storageKey="uw-theme">
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/creator" element={<CharacterCreator />} />
            <Route path="/coreskills" element={<CoreSkills />} />
            <Route path="/patrons" element={<Patrons />} />
            <Route path="/otherworldlygifts" element={<OtherworldlyGifts />} />
            <Route path="/challengeof13" element={<ChallengeOf13 />} />
            <Route path="/festivegames" element={<FestiveGames />} />
            <Route path="/cabals" element={<Cabals />} />
            <Route path="/basicterms" element={<BasicTerms />} />
            <Route path="/wealthlevel" element={<WealthLevel />} />
            <Route path="/lifeanddeath" element={<LifeAndDeath />} />
            <Route path="/combat" element={<Combat />} />
            <Route path="/spellcasting" element={<Spellcasting />} />
            <Route path="/bandsandsigns" element={<BandsAndSigns />} />
            <Route path="*" element={<LandingPage />} />
          </Routes>
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
